module.exports = __webpack_public_path__ + "fonts/Inter-Bold.93c1301.woff";